import type { LogoMark } from './types'

export const googleDocs = {
  name: 'Google Docs',
  viewBox: '0 0 64 88',
  body: `<path fill="#3086F6" d="M58,88H6c-3.3,0-6-2.7-6-6V6c0-3.3,2.7-6,6-6h36l22,22v60C64,85.3,61.3,88,58,88z"/> <path fill="#0C67D6" d="M42,0l22,22H42V0z"/> <path fill="#FDFFFF" d="M50,39H14v-5h36V39z M50,46H14v5h36V46z M40,58H14v5h26V58z"/>`,
} as const satisfies LogoMark
